import { render, staticRenderFns } from "./DsAvisosImportantes.vue?vue&type=template&id=795bfffc&scoped=true"
import script from "./DsAvisosImportantes.vue?vue&type=script&lang=js"
export * from "./DsAvisosImportantes.vue?vue&type=script&lang=js"
import style0 from "./DsAvisosImportantes.vue?vue&type=style&index=0&id=795bfffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795bfffc",
  null
  
)

export default component.exports